import { handleResponseOld, makePost } from './helpers';
import { CoverLots } from '@/types/CoverLot';

/**
 * @category Item API
 * @see fetchCoverLots
 */
type FetchCoverLotsParams = {
    authToken?: string;
    catalogIds: any;
    deployment: string;
};

/**
 * @category Item API
 * @see fetchCoverLots
 */
type FetchCoverLotsResponse = {
    data: CoverLots[];
    message: string;
    success: boolean;
};
/**
 * Fetches cover lots via post to Item API Service for given catalogIds
 * @function fetchCoverLots
 * @category Item API
 * @param {FetchCoverLotsParams}
 * @see https://item-api-DEPLOYMENT.liveauctioneers.com/small/cover-lots
 * @see https://github.com/LIVEauctioneers/item-api/blob/master/src/inventory/routes/post-cover-lots.ts
 */
const fetchCoverLots = ({ authToken, catalogIds, deployment }: FetchCoverLotsParams) =>
    new Promise<FetchCoverLotsResponse>((resolve, reject) => {
        const request = makePost({ authToken, deployment, path: '<ITEM-API>small/cover-lots' });
        request.send({ ids: catalogIds });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

export default {
    fetchCoverLots,
};
